<template >
  <base-dialog-form ref="gestGaraDialog" :title="computedTitle" height="90vh"
    :text="garaData && garaData.titolo ? garaData.titolo : ''" color="secondary" icon="mdi-trophy-outline">
    <template v-slot:actions v-if="method !== 'VIEW'">
      <v-row>
        <v-col cols="12" class="text-center">
          <v-btn class="mx-5" v-if="method !== 'VIEW'" @click="saveGara" color="success">{{ $t("save") }}</v-btn>
          <v-btn class="mx-5" v-if="method === 'EDIT'" @click="deleteGara" color="error">{{ $t("delete") }}</v-btn>
        </v-col>
      </v-row>
    </template>
    <v-row class="mb-2">
      <v-tabs v-model="tabs" background-color="transparent" color="secondary" slider-color="secondary">
        <v-tab id="tab-title" class="mr-3">
          <v-icon class="mr-2">mdi-trophy</v-icon>
          {{ $t("match_data") }}
        </v-tab>
        <v-tab id="tab-descr" class="mr-3">
          <v-icon class="mr-2">mdi-book-open-outline</v-icon>
          {{ $t("long_description") }}
        </v-tab>
      </v-tabs>
    </v-row>
    <form>
      <v-tabs-items v-model="tabs" class="transparent tabs-container">
        <v-tab-item>
          <v-row>
            <v-col md="6" cols="12" class="text-center">
              <v-row>
                <v-col cols="12">
                  <v-text-field v-model="garaData.titolo" :disabled="method === 'VIEW'" :label="$t('title')"
                    :rules="required" hide-details="auto"></v-text-field>
                </v-col>

                <v-col md="2" cols="12">
                  <v-layout row wrap justify-center>
                    <v-switch :true-value="1" :false-value="0" v-model="garaData.attiva"
                      :label="$t('active_f_s')"></v-switch>
                  </v-layout>
                </v-col>

                <v-col md="5" cols="6">
                  <my-datepicker v-model="garaData.dateInz" :disabled="method === 'VIEW'" :label="$t('start')"
                    required="true" :manageTime="true" />
                </v-col>
                <v-col md="5" cols="6">
                  <my-datepicker v-model="garaData.dateEnd" :disabled="method === 'VIEW'" :label="$t('end')"
                    required="true" :manageTime="true" />
                </v-col>

                <v-col md="4" cols="12">
                  <v-autocomplete v-model="garaData.idCommissario" :items="listUsers" item-text="fullName"
                    item-value="masterId" :disabled="method === 'VIEW'" :menu-props="{ maxHeight: '400' }"
                    :label="$t('commisioner_of_contest')" color="primary" :hint="$t('select_user')"
                    persistent-hint></v-autocomplete>
                </v-col>
                <v-col md="4" cols="12">
                  <v-select v-model="garaData.locId" :items="listLocation" :disabled="method === 'VIEW'"
                    :menu-props="{ maxHeight: '400' }" :label="$t('location')" required color="primary"
                    :hint="$t('pick_your_location')" persistent-hint></v-select>
                </v-col>
                <v-col md="4" cols="12">
                  <v-text-field v-model="garaData.screenLines" type="number" :disabled="method === 'VIEW'"
                    :label="$t('screen_lines')" :rules="required" hide-details="auto"></v-text-field>
                </v-col>

              </v-row>
            </v-col>
            <v-col md="6" cols="12" text-center>
              <my-img-uploader ref="imageUploader" v-model="garaData.image" :readOnly="method === 'VIEW'" :width="600"
                :height="300" :placeholder="$t('click_drag_here')"></my-img-uploader>
            </v-col>
          </v-row>
        </v-tab-item>
        <v-tab-item>
          <tiptap-vuetify :extensions="extensions" class="fullDex" :disabled="method === 'VIEW'"
            v-model="garaData.descr"></tiptap-vuetify>
        </v-tab-item>
      </v-tabs-items>
    </form>
  </base-dialog-form>
</template>
<script>
import Swal from "sweetalert2";
import MyDatepicker from "@/components/base/MyDatepicker.vue";
import MyImageUploader from "@/components/base/MyImageUploader.vue";

import {
  TiptapVuetify,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Code,
  Paragraph,
  BulletList,
  OrderedList,
  ListItem,
  Link,
  Blockquote,
  HardBreak,
  HorizontalRule,
  History,
} from "tiptap-vuetify";

export default {
  name: "gest-gara",

  components: {
    MyDatepicker,
    TiptapVuetify,
    "my-img-uploader": MyImageUploader,
  },
  data() {
    return {
      idGara: null,
      method: null,
      listUsers: [],
      extensions: [
        History,
        Blockquote,
        Link,
        Underline,
        Strike,
        Italic,
        ListItem,
        BulletList,
        OrderedList,
        [
          Heading,
          {
            options: {
              levels: [1, 2, 3],
            },
          },
        ],
        Bold,
        Code,
        HorizontalRule,
        Paragraph,
        HardBreak,
      ],
      garaData: {},
      tabs: null,
      listLocation: null,
      RBAC_USER_VIEW_OTHER_USER: false,
      listSchede: [],
      initalImage: null,
      required: [(value) => !!value || this.$t("required_field")],
      requiredNumber: [
        (value) => (!!value && !isNaN(value)) || this.$t("required_field"),
      ],
    };
  },
  methods: {
    open(method, idGara) {
      this.method = method;
      this.idGara = idGara;
      this.$refs.gestGaraDialog.open();
      this.loadData();
    },
    loadData() {
      let _ = this;
      _.isFetching = true;

      if (_.idGara !== null) {
        let url = "/auth/eventi/getGara/" + _.idGara;
        // Eventi aperti
        _.chiamataAxios("GET", url, { body: { onlyTestata: true } }).then(
          (response) => {
            _.garaData = response.data;
          }
        );
      } else {
        _.garaData = { screenLines: 6 };
      }
    },
    deleteGara() {
      let _ = this;
      Swal.fire({
        title: this.$t("are_you_sure_?"),
        text: this.$t("you_cant_revert_this"),
        type: "warning",
        showCancelButton: true,
        customClass: "v-application",
        confirmButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        cancelButtonClass:
          "mx-5 v-btn v-btn--contained theme--light v-size--default",
        confirmButtonText: this.$t("yes_delete"),
        cancelButtonText: this.$t("back"),
        buttonsStyling: true,
      }).then((result) => {
        if (result.value) {
          _.chiamataAxios("DELETE", "/auth/eventi/deleteGara/" + _.idGara).then(
            (resp) => {
              if (resp.msg.severity === 0) {
                let html = "<strong>" + response.msg.msgTxt + "</strong>"
                Swal.fire({
                  type: "success",
                  html: html,
                });
                _.$emit("isUpdated", "true");
                _.$refs.gestGaraDialog.close();
              }
            }
          );
        }
      });
    },
    saveGara: function () {
      let _ = this;
      _.$refs.imageUploader.updateImage();
      _.chiamataAxios(
        "PUT",
        "/auth/eventi/saveGara/" + (_.method === "EDIT" ? _.idGara : ""),
        { body: _.garaData }
      ).then((resp) => {
        if (resp.msg.severity === 0) {
          let html = "<strong>" + resp.msg.msgTxt + "</strong>"
          Swal.fire({
            type: "success",
            html: html,
          });
          _.$emit("isUpdated", "true");
          _.$refs.gestGaraDialog.close();
        }
      });
    },
  },
  computed: {
    computedTitle: function () {
      if (this.method === "EDIT") return this.$t("edit_match");
      else if (this.method === "ADD") return this.$t("create_match");
      else return "";
    },
  },
  mounted() {
    let _ = this;
    _.listUsers = [];
    _.RBAC_USER_VIEW_OTHER_USER = this.checkUserRole("user", "VIEW_OTHER_USER");
    if (_.RBAC_USER_VIEW_OTHER_USER) {
      _.chiamataAxios("POST", "/auth/portal/listUsers").then((resp) => {
        _.listUsers = resp.data;
      });
      _.listLocation = [];
      _.chiamataAxios("GET", "/auth/eventi/listLocation").then((resp) => {
        _.listLocation = resp.data.locations.map(function (item) {
          return { value: item.id, text: item.nome };
        });
      });
      this.loadData();
    }
  },
  watch: {
    idGara: function (newVal, oldVal) {
      // watch it
      this.loadData();
    },
  },
};
</script>
<style>
.fullDex .tiptap-vuetify-editor__content {
  max-height: 450px;
}
</style>